import { useTranslation } from "react-i18next";

import AddNewUsersContext from './AddNewUsers.context';
import AddNewUsersSkeleton from './Skeleton';
import addNewUsers from './addNewUsers.form';
import useAddNewUsers from './useAddNewUsers';

import { IDialogChildComponent } from "../../../../../reducers/dialog";

import DynamicForm from "../../../../../yoello-lib/modules/dynamicForms/DynamicForms";
import EColourPanel from "../../../../../interfaces/EColourPanel";

import useCheckPermissions from "../../../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../../../const/permissions.const";
import { ICallAPIFunction } from "../../../../../yoello-lib/modules/API2/types";

interface IAddNewUsers extends IDialogChildComponent {
  venueId: string;
  invitationsListApi:ICallAPIFunction<any>;
}

const AddNewUsers = ({ onClose, venueId,invitationsListApi }: IAddNewUsers) => {
  const { t } = useTranslation();
  const {
    onSubmit,
    isLoadingPermissions,
    permissions,
    state,
    dispatch,
    isLoading
  } = useAddNewUsers(venueId, onClose,invitationsListApi)

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.USER_MANAGEMENT);

  const { email_list, hasSelectedPermission } = state;

  
  return !isLoadingPermissions && permissions?.length && !isLoading ? (
      <AddNewUsersContext.Provider
        value={{
          ...state,
          dispatch
        }}
      >
        <DynamicForm
          onHandleSubmit={onSubmit}
          disableAll={!hasPermission}
          disableAllInteraction={onFailedInteraction}
          formData={{permissions, email_list: email_list??[]}}
          formRows={addNewUsers(t)}
          formKeyName="confirm-email"
          useFormOptions={{
            reValidateMode: "onSubmit"
          }}
          isDialog={true}
          formButtons={{
            rightButton: {
              type: 'submit',
              label: email_list.length < 1 ?
                t(`userManagement.formButtons.sendInvitations`):
                t("userManagement.formButtons.sendInvitationsMultiple", {number: email_list.length}),
              color: EColourPanel.PRIMARY,
              disabled: email_list.length < 1 || !hasSelectedPermission || !hasPermission
            },
            leftButton: {
              type: 'button',
              label: t('delete.cancel'),
              onClick: onClose,
              color: EColourPanel.PRIMARY,
            }
          }}
        />
      </AddNewUsersContext.Provider>
  ) : <AddNewUsersSkeleton />
}

export default AddNewUsers;
